import type { APIFilterState } from '@/_containers';

/** Shared defaults for the main invoices table list (standalone + split shell). */
export const invoicesMainListDefaultApiFilter: Partial<APIFilterState> = {
  per_page: 50,
  sort: '-invoice_number',
};

/**
 * Infinite-query param prefix when using {@link invoicesMainListDefaultApiFilter} and page 1 (matches `stripPageParam(apiParamStr)`).
 */
export const invoicesMainListInfiniteLoaderParams = (() => {
  const params = Object.entries(invoicesMainListDefaultApiFilter).flatMap(([key, value]) =>
    value !== undefined && value !== null ? [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`] : []
  );
  return params.length > 0 ? `?${params.join('&')}` : '';
})();
